/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAddYourListsResponse
 */
export interface ControlAddYourListsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlAddYourListsResponse
     */
    form_ids: Array<string>;
}

/**
 * Check if a given object implements the ControlAddYourListsResponse interface.
 */
export function instanceOfControlAddYourListsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "form_ids" in value;

    return isInstance;
}

export function ControlAddYourListsResponseFromJSON(json: any): ControlAddYourListsResponse {
    return ControlAddYourListsResponseFromJSONTyped(json, false);
}

export function ControlAddYourListsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAddYourListsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form_ids': json['form_ids'],
    };
}

export function ControlAddYourListsResponseToJSON(value?: ControlAddYourListsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form_ids': value.form_ids,
    };
}

